import { t } from "@/i18n-js/instance";
import type { Event } from "@circle-react/types";
import { Typography } from "@circle-react-uikit/Typography";
import { Attendees } from "./Attendees";
import { MetaTags } from "./MetaTags";
import { Permissions } from "./Permissions";

interface AdvancedOptionsProps {
  event: Event;
}

export const AdvancedOptions = ({ event }: AdvancedOptionsProps) => (
  <>
    <Typography.TitleXl>
      {t("events.edit_modal.advanced_options.title")}
    </Typography.TitleXl>
    <Permissions />
    <Attendees event={event} />
    <MetaTags />
  </>
);
